'use strict';

import angular from 'angular';

import containerDirective from './container';

const MODULE_NAME = 'daupler.incidents.components.log';

var app = angular.module(MODULE_NAME, [
]);
app.directive('incidentLogContainer', containerDirective);

export default MODULE_NAME;
